import { Reveal, Chapter } from "./shared";

const bullets = [
  "How you're matched, and how today feels between you",
  "Their day and yours, side by side",
  "A 7 day look ahead for everyone you've added",
];

export const People = () => (
  <section className="py-16 sm:py-24 lg:py-32 bg-[#F2F0EB] text-[#0B0B0C]" data-testid="people-section">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <Chapter label="Code-to-code" />
      </Reveal>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <Reveal className="lg:col-span-6">
          <h2 className="h-heavy text-[32px] sm:text-5xl lg:text-6xl leading-[0.95]" data-testid="people-headline">
            Understand the people
            <br />
            <span className="text-[#FF4D0A]">you care about.</span>
          </h2>
          <p className="mt-8 text-[#55585E] leading-relaxed max-w-md" data-testid="people-body">
            Add the people you deal with. See their day next to yours, and the
            best window to talk.
          </p>
        </Reveal>
        <div className="lg:col-span-6 flex flex-col justify-center gap-0">
          {bullets.map((b, i) => (
            <Reveal key={b} delay={i * 0.1}>
              <div className="flex gap-5 items-start border-t border-[#0B0B0C]/15 py-5" data-testid={`people-bullet-${i + 1}`}>
                <span className="font-mono-brand text-xs text-[#FF4D0A] mt-0.5">/{String(i + 1).padStart(2, "0")}</span>
                <p className="text-[#0B0B0C] leading-relaxed">{b}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
